export const ChartColors = {
    primary: '#059669', // Emerald
    primaryLight: 'rgba(5, 150, 105, 0.2)',
    info: '#3b82f6',    // Blue
    infoLight: 'rgba(59, 130, 246, 0.2)',
    danger: '#ef4444',  // Red
    dangerLight: 'rgba(239, 68, 68, 0.2)',
    warning: '#f59e0b', // Amber
    warningLight: 'rgba(245, 158, 11, 0.2)',
    success: '#10b981', // Emerald
    successLight: 'rgba(16, 185, 129, 0.2)',
    surface: '#ffffff',
    text: '#64748b',
    border: '#e2e8f0'
};

const CURATED_PALETTE = [
    '#10b981', // Emerald (Success)
    '#3b82f6', // Blue (Info)
    '#f59e0b', // Amber (Warning)
    '#ef4444', // Red (Danger)
    '#6366f1', // Indigo
    '#8b5cf6', // Violet
    '#f97316', // Orange
    '#06b6d4', // Cyan
    '#ec4899', // Rose
    '#64748b'  // Slate (Lainnya/Neutral)
];

/**
 * Generates a set of distinct, vibrant colors.
 * Uses a curated palette for 10 items, otherwise falls back to HSL rotation.
 */
export const getDistinctPalette = (count: number): string[] => {
    if (count <= 10) {
        return CURATED_PALETTE.slice(0, count);
    }

    const palette: string[] = [];
    const saturation = 80;

    for (let i = 0; i < count; i++) {
        const hue = (i * (360 / count)) % 360;
        const lightness = i % 2 === 0 ? 50 : 70;
        palette.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    return palette;
};

export const ChartFonts = {
    family: "'Roboto', sans-serif" // Matching body font
};
